"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coinv2 = exports.isCoin = exports.Units = void 0;
var big_js_1 = __importDefault(require("big.js"));
var ow_1 = __importDefault(require("ow"));
var ow_types_1 = require("../ow.types");
var cro_1 = require("../../core/cro");
var coins_1 = require("../../cosmos/coins");
var Units;
(function (Units) {
    Units["BASE"] = "base";
    Units["CRO"] = "cro";
})(Units = exports.Units || (exports.Units = {}));
function isCoin(object) {
    return object.hasOwnProperty('baseAmount');
}
exports.isCoin = isCoin;
exports.coinv2 = function (config) {
    var _a;
    return _a = (function () {
            function CoinV2(amount, unit, denom) {
                ow_1.default(amount, 'amount', ow_1.default.string);
                ow_1.default(denom, 'denom', ow_1.default.optional.string);
                ow_1.default(unit, 'unit', ow_types_1.owCoinUnit);
                var coins;
                try {
                    coins = new big_js_1.default(amount);
                }
                catch (err) {
                    throw new TypeError("Expected amount to be a base10 number represented as string, got `" + amount + "`");
                }
                this.network = config.network;
                this.baseAmount = coins;
                if (unit === Units.BASE) {
                    this.baseAmount = CoinV2.parseBaseAmount(coins);
                }
                else if (unit === Units.CRO) {
                    if (typeof denom === 'undefined') {
                        this.baseAmount = CoinV2.parseCROAmount(coins);
                    }
                    else if (['cro', 'tcro'].includes(denom.toLowerCase())) {
                        this.baseAmount = CoinV2.parseCROAmount(coins);
                    }
                    else if (!['cro', 'tcro'].includes(denom.toLowerCase())) {
                        throw new Error('Provided Units and Denom do not belong to the same network.');
                    }
                }
                this.denom = denom || this.network.coin.baseDenom;
                this.receivedAmount = coins;
            }
            CoinV2.prototype.getNetwork = function () {
                return this.network;
            };
            CoinV2.parseBaseAmount = function (baseAmount) {
                if (baseAmount.cmp(baseAmount.toFixed(0)) !== 0) {
                    throw new TypeError("Expected base amount to be an integer, got `" + baseAmount + "`");
                }
                if (baseAmount.lt(0)) {
                    throw new TypeError("Expected base amount to be positive, got `" + baseAmount + "`");
                }
                if (baseAmount.gt(CoinV2.TOTAL_SUPPLY_STRING)) {
                    throw new TypeError("Expected base amount to be within total supply, got `" + baseAmount + "`");
                }
                return baseAmount;
            };
            CoinV2.parseCROAmount = function (croAmount) {
                var baseAmount = croAmount.mul(CoinV2.ONE_CRO_IN_BASE_UNIT);
                if (baseAmount.cmp(baseAmount.toFixed(0)) !== 0) {
                    throw new TypeError("Expected CRO amount to have at most 8 decimal places, got `" + croAmount + "`");
                }
                if (baseAmount.lt(0)) {
                    throw new TypeError("Expected CRO amount to be positive, got `" + croAmount + "`");
                }
                if (baseAmount.gt(CoinV2.TOTAL_SUPPLY_STRING)) {
                    throw new TypeError("Expected CRO amount to be within total supply, got `" + croAmount + "`");
                }
                return baseAmount;
            };
            CoinV2.fromBaseUnit = function (baseValue) {
                return new CoinV2(baseValue, Units.BASE);
            };
            CoinV2.fromCRO = function (croValue) {
                return new CoinV2(croValue, Units.CRO);
            };
            CoinV2.prototype.toCosmosCoin = function () {
                return coins_1.coin(this.toString(Units.BASE), this.denom);
            };
            CoinV2.prototype.toCosmosCoins = function () {
                return coins_1.coins(this.toString(Units.BASE), this.denom);
            };
            CoinV2.prototype.toString = function (unit) {
                if (unit === void 0) { unit = Units.BASE; }
                ow_1.default(unit, ow_types_1.owCoinUnit);
                if (!CoinV2.croAllDenoms.includes(this.denom)) {
                    return this.receivedAmount.toString();
                }
                if (unit === Units.BASE) {
                    return this.baseAmount.toString();
                }
                return this.baseAmount.div(CoinV2.ONE_CRO_IN_BASE_UNIT).toString();
            };
            return CoinV2;
        }()),
        _a.croAllDenoms = __spreadArrays(Object.values(cro_1.CroNetwork.Mainnet.coin), Object.values(cro_1.CroNetwork.Testnet.coin)),
        _a.TOTAL_SUPPLY_STRING = '10000000000000000000',
        _a.TOTAL_SUPPLY = new _a(_a.TOTAL_SUPPLY_STRING, Units.BASE),
        _a.ONE_CRO_IN_BASE_UNIT = new big_js_1.default('100000000'),
        _a.UNIT_BASE = Units.BASE,
        _a.UNIT_CRO = Units.CRO,
        _a.fromCustomAmountDenom = function (amount, denom) {
            return new _a(amount, Units.BASE, denom);
        },
        _a;
};
//# sourceMappingURL=v2.coin.js.map